module.exports = __webpack_public_path__ + "img/HLF.a1a84575.svg";